import EQUIPMENT_MESSAGE from "../../../../../CustomLiquiImages/EquipmentMessage.png";
import INVENTORY_MESSAGE from "../../../../../CustomLiquiImages/InventoryMessage.png";
import LEADERBOARD_MESSAGE from "../../../../../CustomLiquiImages/LeaderboardMessage.png";
import SKILLS_MESSAGE from "../../../../../CustomLiquiImages/SkillsMessage.png";

import SKILLS_ICON from "../../../../../Icons/SkillsIcon.png";
import EQUIPMENT_ICON from "../../../../../Icons/EquipmentIcon.png";
import INVENTORY_ICON from "../../../../../Icons/InventoryIcon.png";
import LEADERBOARD_ICON from "../../../../../Icons/LeaderboardIcon.png";

export type ConversationIndividualType = {
    image: string;
    info: { icon: string; name: string; title: string; info: string };
    flip: boolean;
};

export type ConversationDataType = {
    [key: string]: ConversationIndividualType;
};
export const ConversationData: ConversationDataType = {
    skillsMessage: {
        image: SKILLS_MESSAGE,
        info: {
            icon: SKILLS_ICON,
            name: "Skills",
            title: "Track your progress!",
            info: "LiquiBot currently offers four skills you can progress through. Your activity level will directly correlate to the amount you are active in your server, while the other skills can be progressed by interacting with commands. Smithing and Mining can be leveled up from smelting ores, creating armor and mining raw materials. Your Melee skill can be leveled up through fighting.",
        },
        flip: false,
    },
    equipmentMessage: {
        image: EQUIPMENT_MESSAGE,
        info: {
            icon: EQUIPMENT_ICON,
            name: "Equipment",
            title: "Upgrade your equipment!",
            info: "Combat is an essential element of LiquiBot. As you level up you will be able to defeat difficult bosses. These bosses can reward you with new items to increase your chances of progressing to the next level. The equipment command will show you how you stack up to the competition.",
        },
        flip: true,
    },
    inventoryMessage: {
        image: INVENTORY_MESSAGE,
        info: {
            icon: INVENTORY_ICON,
            name: "Inventory",
            title: "Hoarding is warranted!",
            info: "Items are the bread and butter of your grind. Getting better items can enable your character too complete more parts of the game. The more you can complete, the better items you get. A nice compounding effect occurs. Show off your items using the inventory command!",
        },
        flip: false,
    },
    leaderboardMessage: {
        image: LEADERBOARD_MESSAGE,
        info: {
            icon: LEADERBOARD_ICON,
            name: "Leaderboards",
            title: "Are you competitive?",
            info: "Competition is a driving force of nations. Liquibot taps into that drive to encourage progression and friendly competition in all players. Check out how you stack up against everyone else with the leaderboard command.",
        },
        flip: true,
    },
};

export const ConversationDataPairs = [
    [SKILLS_MESSAGE, EQUIPMENT_MESSAGE],
    [INVENTORY_MESSAGE, LEADERBOARD_MESSAGE],
];
